import { ErrorMessage } from "@/app/components/error-message";
import { Card } from "@/components/card";
import { ListItem } from "@/components/list-item";
import { LoadingScreen } from "@/components/loading-screen";
import { buttonVariants } from "@/components/ui/button";
import { useGetOrganisation } from "@/features/organisations/api/get-organisation";
import { bytesToGi } from "@/features/recordings/utils/bytes-to-gb";
import { OnboardingHeader } from "@/features/registration/components/onboarding-header";
import { useOrganisation } from "@/features/select-organisation/api/get-my-organisation";

export function LicensePage() {
  const { organisation } = useOrganisation();
  const { data, isLoading, isSuccess, isError, error } = useGetOrganisation({
    id: organisation.id,
  });

  if (isLoading)
    return (
      <div>
        <OnboardingHeader title="Licence Details" className="mb-6" />
        <LoadingScreen />
      </div>
    );

  if (isError || !isSuccess)
    return (
      <div>
        <OnboardingHeader title="Licence Details" className="mb-6" />
        <ErrorMessage error={error} />
      </div>
    );

  return (
    <div>
      <OnboardingHeader title="Licence Details" className="mb-6" />

      <Card>
        <Card.Header title="Details" />
        <Card.Content className="py-0">
          <dl className="divide-y divide-border">
            <ListItem
              label="Licence Level"
              value={data.license.name.toLowerCase()}
            />

            <ListItem
              label="Storage"
              value={`${data.license.storageInGB} GB (${bytesToGi(data.totalStorageUsedBytes)} GB used)`}
            />
            <ListItem
              label="Permanent Storage"
              value={`${bytesToGi(data.permanentStorageUsedBytes)} GB`}
            />
            <ListItem
              label="Storage Duration"
              value={`${data.license.storageDurationInDays} days`}
            />
            <ListItem
              label="Replay"
              value={data.license.replay.toLowerCase()}
            />
            <ListItem
              label="Events"
              value={
                data.license.isGivenEventAccess ? (
                  "Yes"
                ) : (
                  <>
                    <span>-</span>{" "}
                    <a
                      href="https://classview.com/contact-us?utm_source=classview-license-page&utm_medium=referral"
                      target="_blank"
                      rel="noopener noreferrer"
                      className={buttonVariants({ variant: "link" })}
                    >
                      Contact Sales
                    </a>
                  </>
                )
              }
            />
          </dl>
        </Card.Content>
      </Card>
    </div>
  );
}
